import { render } from "./BackorderListView.vue?vue&type=template&id=5d8414e5&scoped=true"
import script from "./BackorderListView.vue?vue&type=script&lang=js"
export * from "./BackorderListView.vue?vue&type=script&lang=js"

import "./BackorderListView.vue?vue&type=style&index=0&id=5d8414e5&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8414e5"]])

export default __exports__